export enum SubscriptionType {
    Monthly = 'Monthly',
    Yearly = 'Yearly',
    OnUse = 'OnUse',
    Tiered = 'Tiered',
}

export const SubscriptionTypeTranslations: Record<SubscriptionType, string> = {
    [SubscriptionType.Monthly]: 'شهري',
    [SubscriptionType.Yearly]: 'سنوي',
    [SubscriptionType.OnUse]: 'حسب الاستخدام',
    [SubscriptionType.Tiered]: 'متدرج',
};
